import { gameModuleStore } from "../store/gameModuleStore";
import { gameModuleService } from "./gameModuleService";
import { GAME_SPEED_TYPES } from "../../constants/gameConstants";

class GameControlService {

    standardSpin = () => this._spin(GAME_SPEED_TYPES.standard)

    fastSpin = () => this._spin(GAME_SPEED_TYPES.fast)

    turboSpin = () => this._spin(GAME_SPEED_TYPES.turbo)

    standardStop = (result) => this._stop(result, true)

    fastStop = (result) => this._stop(result, true)

    // RU: в турбо force stop не нужен — барабан и так идёт мимо, поэтому отложенный «посадить»
    //     здесь не взводится намеренно (MIGRATION-CLASSIC §2.5).
    turboStop = (result) => this._stop(result, false)

    forceStop = () => {
        if (gameModuleService.skippableAnimationPromise.length) {
            gameModuleService.skipAnimations()
        }
        if (gameModuleStore.responseReady && !gameModuleStore.awaitForceStop) gameModuleStore.setIsForceStop(true)
        gameModuleStore.setAwaitForceStop(true)
    }

    // Ядро зовёт pauseGame/resumeGame БЕЗ `?.` (пауза от лаунчера через
    // postMessage) — без них игра падает с `is not a function`.
    pauseGame = () => {
        // Досаживаем выигрышные анимации в конечный кадр: под паузой тикер может
        // стоять, и анимация иначе замрёт на середине.
        gameModuleService.endAllWinAnimations()
    }

    resumeGame = () => {
        // Пусто намеренно: ни бонуса, ни докупки у игры нет — восстанавливать
        // нечего. Метод существует потому, что ядро зовёт его безусловно.
    }

    _spin = (speedType) => {
        gameModuleStore.setSpinSpeedType(speedType)
        gameModuleService.startSpin()
        gameModuleStore.setIsForceStop(false)
        gameModuleStore.setAwaitForceStop(false)
    }

    // RU: порядок один на все три скорости: `additional` — ДО посадки. Турбо-барабан садится
    //     синхронно внутри `stopAnimation` и уже читает из `additional` раскрытые wild; на
    //     стандартной и быстрой скорости отложенный force stop садит барабаны так же сразу.
    _stop = ({ matrix, additional }, canHurry) => {
        gameModuleStore.setAdditional(additional)
        gameModuleService.stopAnimation(matrix)
        if (canHurry && gameModuleStore.awaitForceStop) gameModuleStore.setIsForceStop(true)
    }
}


export const gameControlService = new GameControlService()
